module.exports = __webpack_public_path__ + "img/calendar-date.37256f34.svg";